import { render } from "./TheLogout.vue?vue&type=template&id=259cd20c"
import script from "./TheLogout.vue?vue&type=script&lang=js"
export * from "./TheLogout.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__